import { React, useEffect, useState } from "react";
import PlantillaScreen from "../helpers/PlantillaScreen";
import { LoaderScreen } from "../components/LoaderScreen";
import request from "../../Helpers/API";
import Swal from "sweetalert2";
import { useHistory, useLocation } from "react-router-dom";
import { MensajeriaListadoContactos } from "./MensajeriaListadoContactos";
import { MensajeriaListadoFiltroGlobal } from "./MensajeriaListadoFiltroGlobal";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { FiltroMensajeriaEnviada } from "./FiltroMensajeriaEnviada";
import { ModalDetalleMensajesEnviados } from "./ModalDetalleMensajesEnviados";
import FiltroMultiple from "../Postventa/Dashboard/Modales/FiltroMultiple";

export const MensajeriaEnviadosDetalleScreen = () => {
    const history = useHistory();
    const location = useLocation();

    const fecha = location.state?.fecha || 0;
    const seccion = location.state?.seccion || 0;



    const [mensajeria, setMensajeria] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [tipoMensaje, setTipoMensaje] = useState("");
    const [modalDatos, setModalDatos] = useState(null);

    // filtros en tabla
    const [options, setOptions] = useState({
        estatus: [],
    });
    const [filtros, setFiltros] = useState({
        estatus: [],
    });
    const [prioridadFiltros, setPrioridadFiltros] = useState([]);
    const [datosFiltrados, setDatosFiltrados] = useState([]);

    const [filtrosTemp, setFiltrosTemp] = useState({
        estatus: []
    });

    const [mostrarFiltro, setMostrarFiltro] = useState({
        estatus: { open: false },
    });
    const [predictivo, setPredictivo] = useState("");


    const actualizarPrioridad = (filtro) => {
        setPrioridadFiltros((prev) => {
            const index = prev.indexOf(filtro);

            let nuevasPrioridades;

            // nuevo filtro → se agrega
            if (index === -1) {
                nuevasPrioridades = [...prev, filtro];
            }
            // filtro existente → se cortan los posteriores
            else {
                nuevasPrioridades = prev.slice(0, index + 1);
            }

            // 🔥 LIMPIAR filtros que perdieron prioridad
            setFiltrosTemp((prevTemp) => {
                const limpio = { ...prevTemp };

                Object.keys(limpio).forEach((key) => {
                    if (!nuevasPrioridades.includes(key)) {
                        limpio[key] = [];
                    }
                });

                return limpio;
            });

            // 🔥 LIMPIAR filtros aplicados también
            setFiltros((prevFiltros) => {
                const limpio = { ...prevFiltros };

                Object.keys(limpio).forEach((key) => {
                    if (!nuevasPrioridades.includes(key)) {
                        limpio[key] = [];
                    }
                });

                return limpio;
            });

            return nuevasPrioridades;
        });
    };

    const aplicarFiltros = (data, filtros, _, filtrosPermitidos = []) => {
        let resultado = [...data];

        filtrosPermitidos.forEach((filtro) => {
            if (filtro === "estatus" && filtros.estatus.length > 0) {
                resultado = resultado.filter((i) => filtros.estatus.includes(i.estado));
            }

        });

        return resultado;
    };

    useEffect(() => {
        if (!Array.isArray(mensajeria)) return;

        let data = [...mensajeria];

        // 🔍 PREDICTIVO (PRIMERO)
        if (predictivo) {
            data = data.filter((item) =>
                item.cliente.toUpperCase().includes(predictivo.toUpperCase())
            );
        }

        // 🔥 FILTROS POR PRIORIDAD
        prioridadFiltros.forEach((filtro) => {
            switch (filtro) {
                case "estatus":
                    if (filtros.estatus.length > 0) {
                        data = data.filter((i) => filtros.estatus.includes(i.estatus));
                    }
                    break;

                default:
                    break;
            }
        });

        setDatosFiltrados(data);
    }, [mensajeria, filtros, prioridadFiltros, predictivo]);

    //Esquema de filtrado en tabla
    useEffect(() => {
        if (!Array.isArray(mensajeria)) return;

        const getBaseData = (filtro) => {
            const index = prioridadFiltros.indexOf(filtro);

            // Si el filtro NO ha sido usado aún → usar data filtrada actual
            if (index === -1) {
                return aplicarFiltros(
                    mensajeria,
                    filtros,
                    null,
                    prioridadFiltros,
                );
            }

            // Si es el primero → data completa
            if (index === 0) {
                return mensajeria;
            }

            // Solo aplicar filtros con MAYOR prioridad
            const filtrosPrevios = prioridadFiltros.slice(0, index);

            return aplicarFiltros(
                mensajeria,
                filtros,
                null,
                filtrosPrevios,
            );
        };

        // ESTATUS
        const estatusOptions = [
            ...new Set(getBaseData("estatus").map((i) => i.estatus)),
        ].map((v) => ({ value: v, label: v }));


        setOptions({
            estatus: estatusOptions,
        });
    }, [mensajeria, filtros, prioridadFiltros]);


    let fechaFormateada = "";
    if (fecha !== "0") {
        // Separar fecha de hora
        const [dia, mes, anio] = fecha.split(" ")[0].split("/");
        // Reordenar a yyyy/mm/dd
        fechaFormateada = `${anio}-${dia}-${mes}`;
    }

    const limpiarFiltros = () => {
        setFiltros({
            estatus: [],
        });

        setFiltrosTemp({
            estatus: [],
        });

        setPrioridadFiltros([]);
        setDatosFiltrados([]);
    };


    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        onExecute();
    }, []);

    const onExecute = () => {
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });

            request
                .get(`MensajeriaEnviada/obtenerDetalle?fecha=${fechaFormateada}&seccion=${seccion}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setMensajeria(result);
                    limpiarFiltros();

                    // setContactosCobranza(result.cobranza ?? []);
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("MENSAJERIA", error, "error");
                    return;
                });
        });
    };


    const onRegresar = () => {
        history.push("/Mensajeria/Listado",
        );
    };

    const onDetalle = (datos) => {
        setModalDatos(datos); // aquí pasamos item.datos
        setTipoMensaje(seccion)
        setModalVisible(true);
    };

    return (
        <PlantillaScreen
            titulo={"DETALLE MENSAJES ENVIADOS WHATSAPP"}
            className={"mensajeria-listado-main-screen"}
            className_main={1}
        >
            <LoaderScreen loader={loader} />

            {modalVisible && (
                <ModalDetalleMensajesEnviados
                    datos={modalDatos}
                    onClose={() => setModalVisible(false)}
                    tipoMensaje={tipoMensaje}
                />
            )}

            <div className="rotacion-cxc-actions">
                <div
                    className="reporte-recuperacion-responsable-actions-regresar"
                    onClick={() => onRegresar()}
                >
                    <ArrowBackIcon />
                    Regresar
                </div>
            </div>

            <div className="mensajeria-listado-chats">

                <div className="mensajeria-listado-tabla-container scroll">
                    <table cellPadding={0} cellSpacing={0}>
                        <thead>
                            <tr>
                                <th>
                                    Cliente
                                </th>
                                <th>
                                    <div>Telefono</div>
                                </th>
                                <th>
                                    <div>Datos</div>
                                </th>
                                <th>
                                    <FiltroMultiple
                                        label="Estatus"
                                        field="estatus"
                                        options={options.estatus}
                                        filtros={filtros}
                                        setFiltros={setFiltros}
                                        filtrosTemp={filtrosTemp}
                                        setFiltrosTemp={setFiltrosTemp}
                                        mostrarFiltro={mostrarFiltro}
                                        setMostrarFiltro={setMostrarFiltro}
                                        actualizarPrioridad={actualizarPrioridad}
                                        setPrioridadFiltros={setPrioridadFiltros}
                                    />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Usar map para renderizar las filas de la tabla */}
                            {datosFiltrados.map((item, index) => (
                                <tr>
                                    <td
                                        className="celda-cliente"

                                    >
                                        {item.cliente}
                                    </td>
                                    <td className="ta-right"
                                    // onClick={() => onDetalle("I", item.iddepartamento, item.departamento)}
                                    >
                                        {item.numeroTelefono}
                                    </td>
                                    <td
                                        // onClick={() => onDetalle("C", item.iddepartamento, item.departamento)}
                                        className="ta-right"
                                    >
                                        <td className="ta-right">
                                            <a
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault(); // evita que el navegador siga el link
                                                    onDetalle(item.datos); // pasamos item.datos
                                                }}
                                            >
                                                {item.datos} {/* Aquí puedes mostrar el nombre del cliente, por ejemplo */}
                                            </a>
                                        </td>
                                    </td>
                                    <td
                                        // onClick={() => onDetalle("F", item.iddepartamento, item.departamento)}
                                        className="ta-left"
                                    >
                                        {item.estatus}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

        </PlantillaScreen>
    )
}